import { path, sortWith, prop, descend } from 'ramda';
import { createSelector } from 'reselect';

export const getOpenAccounts = path(['reports', 'openAccounts']);
export const getKpiStatistics = path(['reports', 'kpiStatistics']);
export const getSortedAccounts = createSelector(getOpenAccounts, accounts => accounts && sortWith([
    descend(prop('date'))
])(accounts))
export const getDashboardStats = path(['reports', 'dashboardStatistics'])